import { BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const WALLET_BASE_URL = BASE_URL + "/wallet"
export const URL_FETCH_WALLET_BALANCE_BY_USER_ID = WALLET_BASE_URL + "/details"

